﻿import {FormattableString} from "@2d-front-monorepo/core";
import {MvvmErrorCollector, MvvmErrorCollectorProps} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import { JSX } from "react";

type PermitsMvvmErrorCollectorProps = Omit<MvvmErrorCollectorProps, "title"> & {
	title?: FormattableString;
};

export default function PermitsMvvmErrorCollector({ title = {text: PermitTranslations.form_error__title}, ...rest }: PermitsMvvmErrorCollectorProps): JSX.Element {
	return <MvvmErrorCollector title={title} {...rest} />;
}
